import Ajax from "Utils/ajax";
export const tipOfTheDayList = (data) => Ajax.post('setting/tipOfTheDayList',data); 
export const removeRow = (data) => Ajax.post('setting/removeTipOfTheDay',data); 
export const addTipOfTheDay = (data) => Ajax.post('setting/tipOfTheDay',data); 
export const tipOfTheDayById = (data) => Ajax.post('setting/tipOfTheDayById',data); 